import { createSlice } from "@reduxjs/toolkit";

export const appointmentSteps = {
    CHOOSE_SCAN: 1,
    PATIENT_DETAILS: 2,
    SELECT_DATE: 3,
};

const initialState = {
    currentStep: appointmentSteps.CHOOSE_SCAN,
    selectedScan: {},
    patientDetails: {},
    selectedDateTime: {},
    discountAmount: 0,
    checkoutId: "",
};

const petCtAppoinmentSlice = createSlice({
    name: "appointment",
    initialState,
    reducers: {
        updateCurrentStep: (state, action) => {
            state.currentStep = action.payload;
        },
        updateSelectedScan: (state, action) => {
            const previousScan = state.selectedScan ?? {};
            const incomingScan = action.payload ?? {};
            state.selectedScan = {
                ...previousScan,
                ...incomingScan,
            };
        },
        updateCheckoutId: (state, action) => {
            state.checkoutId = action.payload;
        },
        updatePatientDetails: (state, action) => {
            state.patientDetails = action.payload;
        },
        updateSelectedDateTime: (state, action) => {
            state.selectedDateTime = action.payload;
        },
        updateDiscountAmount: (state, action) => {
            state.discountAmount = action.payload;
        },
        resetAppointment: () => initialState,
    },
});

export const {
    updateCurrentStep,
    updateSelectedScan,
    updatePatientDetails,
    updateSelectedDateTime,
    resetAppointment,
    updateCheckoutId,
    updateDiscountAmount,
} = petCtAppoinmentSlice.actions;

export const appointmentReducer = petCtAppoinmentSlice.reducer;
